<template>
    <div class="d-flex flex-column tst" v-if='this.fields' ref="inputsContainer"> 
        <div class='container-fluid p-0' v-for="(field, key) in this.fields" :key="key">
            <div v-if="this.no_visible_conditions || (this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['visible'] == true)">
            <Switch v-if='field.type_field == "BOOL"'
                :label='field.name' 
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"  
                :vMark="this.verifMark" 
                :labelTop="isLabelTop"
                @updateParentState="this.setValue"
            />
            <File v-else-if='field.type_field == "FILE" || field.type_field == "FILE_LINK"'  
                :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :arr='true'
                :border='field.alias == "avatar" ? true : false'
                :single='field.alias == "avatar" || field.file_info && field.file_info.count_max == "1" ? true : false' 
                :dataValue='this.dataValues[field.alias]' 
                :id='field.alias' 
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"  
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
                :fileInfoText="false"
                @updateParentState="this.setValue"
                :hint='field.hint'
            />
            <SelectMulti v-else-if='field.custom_multi == "1" && field.haslist'
                :label='field.name' 
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :keywords='this.getKeywords(field)'
                :dataValue='this.dataValues[field.alias]'
                :disable="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"  
                :vMark="this.verifMark"
                :doublebus="this.doublebus"
                :labelTop="isLabelTop"
                :separator="';'"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                @updateParentState="this.setValue"
            />  
            <Select v-else-if='field.haslist && field.custom_multi != "1"'
                :label='field.name' 
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :keywords='this.getKeywords(field)'
                :dataValue='this.dataValues[field.alias]'
                :disable="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :isFilterSelect="true"  
                :vMark="this.verifMark"
                :doublebus="this.doublebus"
                :labelTop="isLabelTop"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                @updateParentState="this.setValue"
            />
            <InputDate v-else-if='field.type_field == "DATE"'
                :id='field.alias' 
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.prepareDateValue(this.dataValues[field.alias])'
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"  
                :vMark="this.verifMark"
                :expFormat="true"
                :labelTop="isLabelTop"
                @updateParentState="this.setDateValue"
            />
            <InputDate v-else-if='field.type_field == "TIME"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                type='time'
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                @updateParentState="this.setValue"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"  
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
            />
            <Address v-else-if='field.type_field == "ADDRESS"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :field="field"
                :addr="this.addr"
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                @updateParentState="this.setValue"  
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
            /> 
            <Input v-else
                type='text' :label='field.name' 
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :labelTop="isLabelTop"
                :disabled="this.no_edit_conditions ? false : (!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1' ? true : false)"
                :verification="field.verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :unvisible="this.unvisible"
                :is_public="field.is_public"
                :vMark="this.verifMark"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                :invalid="field.invalid" 
                :invalidHint="field.invalidHint"
                @updateParentState="this.setValue"
            />
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/components/service/Input';
import Switch from '@/components/service/Switch';
import Select from '@/components/service/Select';
import InputDate from '@/components/service/InputDate';
import File from '@/components/service/File';
import Address from '@/components/service/Address';
import SelectMulti from '@/components/service/SelectMulti';

export default {
    components: {
        Input,
        Switch,
        Select,
        InputDate,
        File,
        Address,
        SelectMulti
    },
    data() {
        return {
            // values: this.getValues(this.dataValues), 
            unvisibleValue: this.unvisibleDataValues ? this.getValues(this.unvisibleDataValues) : false,
            conditions: {},
            containerWidth: 0
        }
    },
    props: {
        fields: [Boolean, Object],
        dataValues: [Boolean, Object],
        unvisibleDataValues: [Boolean, Object],
        unvisible: [Boolean],
        verifMark: [Boolean],
        addr: [Boolean, Object], 
        doublebus: [Boolean],
        no_visible_conditions: [Boolean],
        no_edit_conditions: [Boolean],
        onAlias: [Boolean]
    },
    created() {
        this.conditions = this.setConditions();
    },
    computed: {
        isLabelTop() {
            return this.containerWidth > 0 && this.containerWidth <= 768;
        }
    },
    methods: {
        updateContainerWidth() {
            if (this.$refs.inputsContainer) {
                this.containerWidth = this.$refs.inputsContainer.offsetWidth;
            }
        },
        setValue(arg) {
            console.log('setValue', arg);
            this.$emit('updateParentState', {
                id: arg.id,
                unvisible: arg.unvisible,
                value: arg.value
            })
        },     
        setDateValue(arg) {
            let d = arg.value;
            let v = false; 
            if (d) {
                v = [
                    this.padTo2(d.getDate()),
                    this.padTo2(d.getMonth() + 1),
                    d.getFullYear()
                ].join('.');
            }
            this.$emit('updateParentState', {
                id: arg.id,
                unvisible: arg.unvisible,
                value: v
            })
        },
        setConditions() {
            let ec = {};
            if (!this.fields || !Array.isArray(this.fields)) {
                return ec;
            }
            this.fields.forEach((e) => {
                ec[e.alias + '_conditions'] = this.checkConditions(e);
            })
            return ec;
        },
        prepareDateValue(arg) {
            if (!arg) {
                return '';
            }
            let a = arg.split('.');
            let v = [a[2], a[1], a[0]].join('-');
            return v;
        },  
        padTo2(v) {
            return v.toString().padStart(2, '0');
        },
        checkReg(arg, key) {
            this.fields[key].invalid = false;
            this.fields[key].invalidHint = ''; 
            if (arg.value != '') {
                if (this.fields[key].custom_size != '0' && (arg.value.length < this.fields[key].size_min || arg.value.length > this.fields[key].size_max)) {
                    this.fields[key].invalid = true;
                    this.fields[key].invalidHint = `${this.$t('components.service.GetInputs.1')} ${this.fields[key].size_min} ${this.$t('components.service.GetInputs.2')} ${this.fields[key].size_max} ${this.$t('components.service.GetInputs.3')}`;
                    return;
                }

                if (this.fields[key].re || this.fields[key].custom_regexp) {
                    let re = new RegExp(this.fields[key].re || this.fields[key].custom_regexp);
                    if (re.test(arg.value) == false) {
                        this.fields[key].invalid = true;
                        this.fields[key].invalidHint = `${this.$t('components.service.GetInputs.4')}`;
                    }
                }
            } else if (this.fields[key].obligatory_conditions === '1') {
                this.fields[key].invalid = true;
                this.fields[key].invalidHint = `${this.$t('components.service.GetInputs.5')}`;
            }

        },
        blureInput(arg, key) {
            this.checkReg(arg,key);
            this.$emit('blureInput', {
                id: arg.id,
                value: arg.value,
                key: key,
            })
        },
        setFileValue(arg) {

        },
        getValues(obj) {
            let res = {}
            for (let key in obj) {
                res[key] = obj[key] ? obj[key] : '';
            }
            return res
        },
        getKeywords(field) {
            if (field.type_field == 'KEYT') {
                let keyts = this.$store.getters.get_keyts_keywords
                return keyts
            } else if (field.lists) {
                return field.lists;
            } else {
                let codes = field.type_num_val.split('|');
                let vals = field.type_text_val.split('|');
                let arr = [];
                for (let i = 0; i < codes.length; i++) {
                    arr.push({'code': codes[i], 'value': vals[i]})
                }
                return arr;
            }
        },
        checkConditions(field) {
            let res = {
                edit: true,
                visible: true,
                obligatory: true
            }

            let editConditions = this.parseConditions(field.edit_conditions);
            res.edit = this.evalConditions(editConditions)

            let visibleConditions = this.parseConditions(field.visible_conditions);
            res.visible = this.evalConditions(visibleConditions)

            let obligatoryConditions = this.parseConditions(field.obligatory_conditions);
            res.obligatory = this.evalConditions(obligatoryConditions, false)
            return res;
        },
        parseConditions(str) {
            if (!str) {
                return false;
            }
            try {
                str = str.replace('=', '==').replace('<>', '!=').replace('====', '==').replace('===', '==')
                let grps = [...str.matchAll(/[a-zA-Z0-9_-]{2,}/g)];
                grps.forEach((e) => {
                    if (this.dataValues[e] !== undefined) {
                        str = str.replace(e, 'this.dataValues["'+e+'"]');
                    }
                })
                return str;
            } catch (error) {
                if (this.$store.state.config.CONSOLE_LOGS) { 
                    this.$lib.throwWarning(this.$store, "Can't parse conditional operator "+str + "\n" + error, 'error');
                }
                return false;
            }
        },
        evalConditions(str, def = true) {
            if (!str) {
                return def;
            }
            try {
                return Boolean(eval(str));
            } catch (error) {
                if (this.$store.state.config.CONSOLE_LOGS) { 
                    this.$lib.throwWarning(this.$store, "Can't use conditional operator "+str + "\n" + error, 'error');
                }
                return def;
            }
        }
    },
    mounted() {
        this.updateContainerWidth();
        window.addEventListener('resize', this.updateContainerWidth);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateContainerWidth);
    },
    watch: {
        dataValues: {
            handler(newValue, oldValue) {
                this.fields.forEach((e) => {
                    this.conditions[e.alias + '_conditions'] = this.checkConditions(e);
                })
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
    .tst {
        .container-fluid:first-child {
            div {
                margin-top: 0 !important;
            }
        }
    }
</style>